import { themeColors } from "../../config.js";
export const resizeableStyle = {
  frame: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    position: "absolute",
    backgroundColor: themeColors.backgroundTheme,
    boxShadow: "0 0 10px rgba(0,0,0,0.5)",
  },
  resizerR: {
    position: "absolute",
    cursor: "col-resize",
    height: "100%",
    right: -5,
    top: 0,
    width: "5px",
  },
  resizerB: {
    position: "absolute",
    cursor: "row-resize",
    height: "5px",
    left: 0,
    bottom: -5,
    width: "100%",
  },
};
